import React from 'react';
import styled from 'styled-components';
import { LucideIcon } from 'lucide-react';

interface IconButtonProps {
  icon: LucideIcon;
  onClick: (e: React.MouseEvent) => void;
  title: string;
  variant?: 'default' | 'primary' | 'danger';
  size?: number;
  disabled?: boolean;
}

const StyledButton = styled.button<{ variant: 'default' | 'primary' | 'danger' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: none;
  border-radius: var(--border-radius-md);
  cursor: pointer;
  transition: all 0.2s ease;
  background: transparent;

  ${props => {
    switch (props.variant) {
      case 'primary':
        return `
          color: var(--primary-color);
          &:hover:not(:disabled) {
            background: var(--primary-light);
          }
        `;
      case 'danger':
        return `
          color: var(--error-color);
          &:hover:not(:disabled) {
            background: var(--error-light);
          }
        `;
      default:
        return `
          color: var(--primary-color);
          &:hover:not(:disabled) {
            background: var(--hover-background);
          }
        `;
    }
  }}

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px var(--primary-light);
  }
`;

const IconButton: React.FC<IconButtonProps> = ({
  icon: Icon,
  onClick,
  title,
  variant = 'default',
  size = 18,
  disabled = false
}) => {
  return (
    <StyledButton
      variant={variant}
      onClick={onClick}
      title={title}
      disabled={disabled}
      aria-label={title}
    >
      <Icon size={size} />
    </StyledButton>
  );
};

export default IconButton;
